import _styled from "@emotion/styled/base";
import { jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { LoadingDots } from "./auth-service-tools46.js";
import { borderRadius } from "./auth-service-tools47.js";
import { spacing } from "./auth-service-tools25.js";
import { fontSize } from "./auth-service-tools28.js";
import { fontWeight } from "./auth-service-tools27.js";
import { colors } from "./auth-service-tools26.js";

const StyledButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e14oq8bg0"
} : {
  target: "e14oq8bg0",
  label: "StyledButton"
})({
  height: 40,
  padding: "8px 16px",
  margin: spacing.X8,
  fontSize: fontSize.X15,
  fontWeight: fontWeight.SEMIBOLD,
  color: colors.GRAYSCALE.X0,
  backgroundColor: colors.PRIMARY.REGULAR,
  borderRadius: borderRadius.X8,
  border: "1px solid",
  width: "fit-content"
}, props => {
  const buttonColors = {
    bgColor: colors.PRIMARY.DARK,
    fgColor: colors.GRAYSCALE.X0,
    hoverBgColor: colors.PRIMARY.REGULAR,
    darkBgColor: colors.PRIMARY.DARK,
    borderColor: colors.PRIMARY.DARK,
    hoverFgColor: void 0,
    disabledBgColor: colors.GRAYSCALE.X10,
    disabledBorderColor: colors.GRAYSCALE.X20
  };

  switch (props.variant) {
    case "secondary":
      Object.assign(buttonColors, {
        bgColor: colors.GRAYSCALE.X20,
        fgColor: colors.GRAYSCALE.X70,
        darkBgColor: colors.GRAYSCALE.X30,
        borderColor: colors.GRAYSCALE.X30,
        hoverBgColor: "#D7D9DC"
      });
      break;

    case "tertiary":
      Object.assign(buttonColors, {
        bgColor: colors.GRAYSCALE.X0,
        fgColor: colors.GRAYSCALE.X70,
        darkBgColor: colors.GRAYSCALE.X30,
        borderColor: colors.GRAYSCALE.X30,
        hoverBgColor: colors.GRAYSCALE.X20
      });
      break;

    case "detrimental":
      Object.assign(buttonColors, {
        bgColor: colors.DETRIMENTAL.REGULAR,
        fgColor: colors.GRAYSCALE.X0,
        darkBgColor: colors.DETRIMENTAL.DARK,
        borderColor: colors.DETRIMENTAL.DARK,
        hoverBgColor: "#C62928"
      });
      break;

    case "transparent":
      Object.assign(buttonColors, {
        bgColor: "transparent",
        fgColor: colors.PRIMARY.REGULAR,
        darkBgColor: "transparent",
        borderColor: "transparent",
        hoverBgColor: "transparent",
        hoverFgColor: colors.PRIMARY.DARK,
        disabledBorderColor: "none",
        disabledBgColor: "transparent"
      });
      break;
  }

  const dimensions = props.compact ? {
    height: 28,
    padding: "4px 12px",
    fontSize: fontSize.X12,
    loadingHeight: 6,
    loadingWidth: 30
  } : {
    height: 40,
    padding: "8px 16px",
    fontSize: fontSize.X15,
    loadingHeight: 8,
    loadingWidth: 40
  };
  return {
    backgroundColor: buttonColors.bgColor,
    color: buttonColors.fgColor,
    border: "1px solid",
    borderColor: buttonColors.borderColor,
    height: dimensions.height,
    padding: dimensions.padding,
    fontSize: dimensions.fontSize,
    "&:hover": {
      backgroundColor: buttonColors.hoverBgColor,
      color: buttonColors.hoverFgColor
    },
    "&:active": {
      backgroundColor: buttonColors.darkBgColor
    },
    "&:focus-visible": {
      outline: `2px solid ${colors.GRAYSCALE.X70}`,
      outlineOffset: 2
    },
    "&:disabled": {
      backgroundColor: buttonColors.disabledBgColor,
      color: colors.GRAYSCALE.X30,
      cursor: "default",
      borderColor: buttonColors.disabledBorderColor
    },
    "& .loading-dots-svg": {
      height: dimensions.loadingHeight,
      width: dimensions.loadingWidth
    },
    "& .loading-dots": {
      fill: buttonColors.fgColor
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

const Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    type = "button",
    children,
    loading,
    compact,
    ...rest
  } = _ref;
  return /* @__PURE__ */jsx(StyledButton, {
    ref,
    type,
    compact,
    ...rest,
    children: loading ? /* @__PURE__ */jsx(LoadingDots, {
      centered: true
    }) : children
  });
});
export { Button };